export const reactions = [
  { icon: "👍", name: "thumbsUp", rIcon: "/-strong", rType: 3 },
  { icon: "❤️", name: "heart", rIcon: "/-heart", rType: 5 },
  { icon: "😆", name: "haha", rIcon: ":>", rType: 0 },
  { icon: "😮", name: "surprise", rIcon: ":o", rType: 32 },
  { icon: "😭", name: "cry", rIcon: ":-((", rType: 2 },
  { icon: "😡", name: "angry", rIcon: ":-h", rType: 20 },
];

export default reactions;
